<div class="vault-page-shell">
    <div class="vault-page-header">
      <div class="space-y-3">
        <p class="vault-page-kicker">Profile</p>
        <div class="space-y-2">
        <h2 class="vault-page-title">Account Settings</h2>
        <p class="vault-page-copy max-w-2xl">Manage your account preferences, security details, and data management controls without leaving the vault workspace.</p>
        </div>
      </div>
    </div>
  <div class="vault-divider"></div>

  <div class="grid gap-6 xl:grid-cols-[minmax(0,2fr)_minmax(320px,1fr)]">
    <section class="vault-panel p-6 sm:p-8">
      <div class="space-y-8">
        <div *ngIf="configService.systemConfig$.apiMode === ApiMode.Test" class="space-y-5">
          <div>
            <h2 class="vault-card-title">Profile information</h2>
            <p class="vault-card-copy mt-2">Keep your core account details current so connected services can recognize your vault.</p>
          </div>

          <div class="grid gap-5 md:grid-cols-2">
            <div>
              <label class="vault-field-label">Full name</label>
              <input type="text" class="vault-input" value="Jason Kulatunga">
            </div>
            <div>
              <label class="vault-field-label">Email address</label>
              <input type="email" class="vault-input" value="j***@fastenhealth.com">
            </div>
          </div>

          <button class="vault-primary-button" type="button">Save changes</button>
        </div>

        <div class="space-y-4">
          <div>
            <h2 class="vault-card-title">Security</h2>
            <p class="vault-card-copy mt-2">Manage the ways you sign in and protect access to your records.</p>
          </div>

          <div class="space-y-3">
            <div class="rounded-lg bg-slate-50 p-5">
              <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div class="space-y-1">
                  <h3 class="font-semibold text-slate-900">Password</h3>
                  <p class="text-sm text-slate-500">Update your password to maintain account security.</p>
                </div>
                <button class="vault-secondary-button" type="button">Change</button>
              </div>
            </div>

            <div class="rounded-lg bg-slate-50 p-5">
              <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div class="space-y-1">
                  <h3 class="font-semibold text-slate-900">Passkey</h3>
                  <p class="text-sm text-slate-500">Set up a passkey for a faster and more secure sign-in flow.</p>
                </div>
                <button class="vault-secondary-button" type="button">Set up</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <aside class="vault-panel p-6 sm:p-8">
      <div class="space-y-6">
        <div class="rounded-lg bg-[#EEF2FF] p-5">
          <p class="text-sm font-semibold uppercase tracking-[0.18em] text-[#5B47FB]">Privacy</p>
          <h2 class="vault-card-title mt-3">You stay in control</h2>
          <p class="vault-card-copy mt-2">App and account access can be reviewed from the dashboard at any time before you make permanent changes.</p>
        </div>

        <div class="space-y-4">
          <div>
            <h2 class="text-lg font-semibold text-red-600">Danger Zone</h2>
            <p class="mt-2 text-sm leading-6 text-red-500">These actions affect your vault permanently and should only be used if you intend to remove your account.</p>
          </div>

          <div *ngIf="configService.systemConfig$.apiMode === ApiMode.Test" class="rounded-lg border border-amber-200 bg-amber-50 p-5">
            <div class="space-y-4">
              <div class="space-y-1">
                <h3 class="font-semibold text-amber-700">Reset connection state</h3>
                <p class="text-sm text-amber-600">Clear test vault connections so you can rerun connection and verification flows from a clean slate.</p>
              </div>
              <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <button
                  type="button"
                  class="vault-secondary-button inline-flex items-center justify-center border-amber-300 bg-white text-amber-800 hover:border-amber-400 hover:bg-amber-100 hover:text-amber-900"
                  [disabled]="resetButtonState === 'loading'"
                  [attr.aria-busy]="resetButtonState === 'loading'"
                  (click)="onResetConnections()">
                  <span *ngIf="resetButtonState !== 'loading'">Reset Connections</span>
                  <span *ngIf="resetButtonState === 'loading'">Resetting...</span>
                </button>
                <p class="text-sm text-amber-800" [ngSwitch]="resetButtonState">
                  <span *ngSwitchCase="'success'" class="text-green-700">Connections reset successfully.</span>
                  <span *ngSwitchCase="'error'" class="text-red-700">Unable to reset connections right now.</span>
                  <span *ngSwitchDefault>Only in test mode.</span>
                </p>
              </div>
            </div>
          </div>

          <div class="rounded-lg border border-red-100 bg-red-50 p-5">
            <div class="space-y-4">
              <div class="space-y-1">
                <h3 class="font-semibold text-red-700">Delete Account</h3>
                <p class="text-sm text-red-600">Permanently delete your account and all associated data.</p>
              </div>
              <button class="vault-secondary-button border-red-200 bg-white text-red-600 hover:border-red-300 hover:bg-red-100 hover:text-red-700" type="button">
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </aside>
  </div>
</div>
